module.exports = __webpack_public_path__ + "media/images/china-lang-666b161f2f368b2fc2389080a42ec1cd.png";